import React, { useRef, useState, useEffect, useContext } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import CommonStyle from "../Styles/Common.module.css";
import FontStyle from "../Styles/FontStyle.module.css";
import ButtonStyle from "../Styles/Button.module.css";
import { Link, useParams, useNavigate } from "react-router-dom";
import Search from "./Search";
import { LuSearch } from "react-icons/lu";
import { getUserDashboard } from "../../services/routes.services";
import Carousel from "react-multi-carousel";
import { IMAGE_BASE_URL, API_BASE_URL } from "./../../constants";
import AuthContext from "../../store/auth-context";

const responsiveMain = {
  desktop: { breakpoint: { max: 3000, min: 1024 }, items: 1 },
  tablet: { breakpoint: { max: 1024, min: 464 }, items: 1 },
  mobile: { breakpoint: { max: 464, min: 0 }, items: 1 }
};

const responsiveDots = {
  all: { breakpoint: { max: 4000, min: 0 }, items: 5 }
};

const ResultDashboard =()=>{
    const authCtx = useContext(AuthContext);
    const [searchBox, setSearchBox ] = useState(false);
    const [userListData, setUserListData] = useState([]);
    const [vertualData, setVertualData] = useState([]);
    const navigate = useNavigate();
    const [dateTime, setDateTime] = useState(new Date());
    const [hoveredCarousel, setHoveredCarousel] = useState({});
    const [activeSlides, setActiveSlides] = useState({});
      const mainCarouselRefs = useRef({});
      const dotCarouselRefs = useRef({});
    
      const handleDotClick = (locationId, index) => {
        if (mainCarouselRefs.current[locationId]) {
          mainCarouselRefs.current[locationId].goToSlide(index);
          setActiveSlides((prev) => ({
            ...prev,
            [locationId]: index
          }));
        }
      };
    
    
      
    const showSearchHandler = ()=>{
        setSearchBox(true)
    }
    const closeSearchHandler = ()=>{
        setSearchBox(false)
    }
    useEffect(() => {
        const timer = setInterval(() => {
          setDateTime(new Date());
        }, 1000);
    
        return () => clearInterval(timer); // cleanup
      }, []);
      const formatDateTime = (date) => {
        const pad = (n) => n.toString().padStart(2, '0');
        const year = date.getFullYear();
        const month = pad(date.getMonth() + 1); // Months are 0-indexed
        const day = pad(date.getDate());
        const hours = pad(date.getHours());
        const minutes = pad(date.getMinutes());
        const seconds = pad(date.getSeconds());
    
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      };
      console.log(formatDateTime(dateTime))
    //var token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczpcL1wvd3d3LmJldGEuZWFzeXJlY2NlLmNvbVwvYXBpXC9hdXRoXC91c2VyXC9sb2dpbiIsImlhdCI6MTc0NDc3OTQ4NiwiZXhwIjoxNzc2MzE1NDg2LCJuYmYiOjE3NDQ3Nzk0ODYsImp0aSI6ImpFYjBEaW5sczJWU2RWc0EiLCJzdWIiOjIzLCJwcnYiOiI1YmY1MjBlNDQwN2RhN2NlZjBkYTRhMzZiYmM5ODkzYjgxY2FhYjUyIn0.6ihOu3CoqFlam6eqetjGRHTWoBHBe8xJzncZ0KCaaVU';
    useEffect(()=>{
        const fatchData = async ()=>{
            try{
                const response = await getUserDashboard(authCtx.token);
                setUserListData(response.data.property);
                setVertualData(response.data.vertual_tour)
            }catch(error){
                console.error("Request failed:", error);

            }
        }
        fatchData();
    }, []);
    console.log(userListData)
    const PropertyData = userListData.filter(
    (item, index, self) =>
        index === self.findIndex((t) => t.id === item.id)
    );
    const videoData = vertualData.filter(
    (item, index, self) =>
        index === self.findIndex((t) => t.id === item.id)
    );
    const smoothScroll = (URL, id) => {
        window.scroll({
          top: 0,
          left: 0,
          behavior: "smooth",
        });
      };

      const handleCallback = (data) => {};
      const handleLogoutClick = () => {
        authCtx.logout();
        navigate('/searchResult');
    };
    return(
        <div className={CommonStyle.searchResultPage + " " + CommonStyle.headerSpace}>
            <div className={CommonStyle.breadCrumb}>
                <Container>
                <Row>
                    <Col className={CommonStyle.ulFlex}>
                        <ul>
                            <li><Link to="/" onClick={smoothScroll}>Home</Link></li>
                            <li>Dashboard</li>
                        </ul>
                        {authCtx.isLoggedIn && <Link to="#" onClick={(e) => {e.preventDefault();handleLogoutClick();}} title='Logout'>Logout</Link>}
                    </Col>
                </Row>
                </Container>
            </div>
            <div className={CommonStyle.SearchFilter}>
                <Container>
                <Row>
                    <Col>
                    <div className={CommonStyle.responsiveView + ' ' + CommonStyle.tabSearch}>
                        <button type="button" onClick={showSearchHandler} className={ ButtonStyle.defaultButton + " " + CommonStyle.tabSearchButton}>
                            Search Now <LuSearch className={ButtonStyle.buttonArrow} />
                        </button>
                    </div>
                    {searchBox && 
                        <div className={CommonStyle.searchOverLay}>
                        <div className={CommonStyle.tabSerachContainer}>
                            <button type='button' onClick={closeSearchHandler} className={CommonStyle.closeSearch}><svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none"><path d="M25.1111 10.8889L10.8889 25.1111M10.8889 10.8889L25.1111 25.1111M34 18C34 26.8366 26.8366 34 18 34C9.16345 34 2 26.8366 2 18C2 9.16345 9.16345 2 18 2C26.8366 2 34 9.16345 34 18Z" stroke="white" stroke-width="2.66667" stroke-linecap="round" stroke-linejoin="round"/></svg></button>
                            <Search parentCallback={handleCallback} />
                        </div>
                        </div> 
                    }
                    <div className={CommonStyle.searchBrownBg + ' ' + CommonStyle.desktopView}>
                        <Search parentCallback={handleCallback} />
                    </div>
                    </Col>
                </Row>
                </Container>
            </div>
            <div className={CommonStyle.searchresultArea}>
                <Container>
                    <Row>
                        <Col>
                            <div className={CommonStyle.sendFlex}>
                                <h2 className={FontStyle.Axiforma300 + ' ' + FontStyle.BlackColor}> 
                                property <span className={FontStyle.Axiforma800 + ' ' + FontStyle.OrangeColor}>Tour  Requests</span>
                                </h2>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <div className={CommonStyle.serachListing}>
                            <Row className="filterColumOrder">
                                <Col>
                                <div className={CommonStyle.locationResult}>
                                {PropertyData && PropertyData.length > 0 ? (
                                    <>
                                        {PropertyData.map((LocationDetail) => {
                                            const currentActiveSlide = activeSlides[LocationDetail.id] || 0;
                                        return (
                                            <div className={CommonStyle.width25} key={LocationDetail.id}>
                                            <div className={"areaImgSlider " + CommonStyle.areaImgBox}
                                                onMouseEnter={() => setHoveredCarousel((prev) => ({ ...prev, [LocationDetail.id]: true }))}
                                                onMouseMove={() => setHoveredCarousel((prev) => ({ ...prev, [LocationDetail.id]: true }))}
                                                onMouseLeave={() => setHoveredCarousel((prev) => ({ ...prev, [LocationDetail.id]: false }))}
                                            >
                                            <div className={CommonStyle.sliderContainer}>
                                                <Carousel  
                                                    ref={(el) => (mainCarouselRefs.current[LocationDetail.id] = el)}
                                                    responsive={responsiveMain}
                                                    arrows={true}
                                                    infinite={false}
                                                    showDots={false}
                                                    afterChange={(_, state) => {
                                                    const realIndex = state.currentSlide % LocationDetail.media.length;
                                                    setActiveSlides((prev) => ({
                                                        ...prev,
                                                        [LocationDetail.id]: realIndex,
                                                    }));

                                                    if (dotCarouselRefs.current[LocationDetail.id]) {
                                                        const dotSlider = dotCarouselRefs.current[LocationDetail.id];
                                                        const visibleItems = 5;
                                                        const middleDot = Math.max(realIndex - Math.floor(visibleItems / 2), 0);
                                                        dotSlider.goToSlide(middleDot);
                                                    }
                                                    }}
                                                    autoPlay={!!hoveredCarousel[LocationDetail.id]}
                                                    autoPlaySpeed={1000} 
                                                    pauseOnHover
                                                    swipeable
                                                    draggable
                                                    slidesToSlide={1}
                                                    keyBoardControl
                                                >
                                                {LocationDetail.media.map((LocImage) => {
                                                    return (
                                                    <div className={CommonStyle.item} key={LocImage.id}>
                                                        <Link to={`/property-detail/${LocationDetail.location_code}`}>
                                                        <img src={IMAGE_BASE_URL + "/property/size/" + LocImage.image} alt=""/>
                                                        </Link>
                                                    </div>
                                                    );
                                                })}
                                                </Carousel>
                                                <div className={CommonStyle.linkPost}>
                                                    <div className={CommonStyle.filterList}>
                                                        {(()=>{
                                                            if(LocationDetail?.link_valid_till <= formatDateTime(dateTime) && LocationDetail?.property_allow === 1){
                                                                return <h2 className={CommonStyle.noallow}>Used or Expire </h2>
                                                            }else if(LocationDetail?.property_allow === 0){
                                                                return <h2 className={CommonStyle.pending}>Pending </h2>
                                                            }else if(LocationDetail?.open_limit !== null && LocationDetail?.opened >= Number(LocationDetail?.open_limit) && LocationDetail?.property_allow === 1){
                                                                return <h2 className={CommonStyle.noallow}>Used or Expire</h2>
                                                            }else{
                                                                return <h2 className={CommonStyle.allow}>Available </h2>
                                                            }
                                                        })()}
                                                    </div>
                                                </div>
                                                {/* Dot Carousel */}
                                                <div className={CommonStyle.sliderDots}>
                                                <Carousel
                                                    ref={(el) => (dotCarouselRefs.current[LocationDetail.id] = el)}
                                                    responsive={responsiveDots}
                                                    arrows={true}
                                                    infinite={false}
                                                    swipeable
                                                    draggable
                                                    showDots={false}
                                                    keyBoardControl
                                                    itemClass="dot-carousel-item"
                                                >
                                                    {LocationDetail.media.map((_, index) => (
                                                    <div
                                                        key={index}
                                                        onClick={() => handleDotClick(LocationDetail.id, index)}
                                                        className={currentActiveSlide === index ? CommonStyle.customDot + ' ' + CommonStyle.active : CommonStyle.customDot}
                                                    />
                                                    ))}
                                                </Carousel>
                                                </div>
                                            </div>
                                            </div>
                                            <div className={CommonStyle.areaDetail}>
                                                <h6 className={FontStyle.Axiforma600}>  
                                                {(()=>{
                                                        if(LocationDetail?.link_valid_till <= formatDateTime(dateTime) && LocationDetail?.property_allow === 1){
                                                            return LocationDetail.location_code
                                                        }else if(LocationDetail?.property_allow === 0){
                                                            return LocationDetail.location_code
                                                        }else if(LocationDetail?.open_limit !== null && LocationDetail?.opened >= Number(LocationDetail?.open_limit) && LocationDetail?.property_allow === 1){
                                                            return LocationDetail.location_code
                                                        }else{
                                                            return <Link to={`/property/${LocationDetail.temp_link}`}>{LocationDetail.location_code}</Link>
                                                        }
                                                    })()}
                                                 
                                                </h6> 
                                            </div>
                                            </div>
                                        );
                                        })}
                                    </>
                                    ) : <p>No Data</p>}
                                </div>
                                </Col>
                            </Row>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <div className={CommonStyle.sendFlex}>
                                <h2 className={FontStyle.Axiforma300 + ' ' + FontStyle.BlackColor}> 
                                Virtual <span className={FontStyle.Axiforma800 + ' ' + FontStyle.OrangeColor}>Tour Requests</span>
                                </h2>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <div className={CommonStyle.serachListing}>
                            <Row className="filterColumOrder">
                                <Col>
                                <div className={CommonStyle.locationResult}>
                                {videoData && videoData.length > 0 ? (
                                    <>
                                        {videoData.map((LocationDetail) => {
                                            const currentActiveSlide = activeSlides[LocationDetail.id] || 0;
                                        return (
                                            <div className={CommonStyle.width25} key={LocationDetail.id}>
                                            <div className={"areaImgSlider " + CommonStyle.areaImgBox}
                                                onMouseEnter={() => setHoveredCarousel((prev) => ({ ...prev, [LocationDetail.id]: true }))}
                                                onMouseMove={() => setHoveredCarousel((prev) => ({ ...prev, [LocationDetail.id]: true }))}
                                                onMouseLeave={() => setHoveredCarousel((prev) => ({ ...prev, [LocationDetail.id]: false }))}
                                            >
                                            <div className={CommonStyle.sliderContainer}>
                                                <Carousel  
                                                    ref={(el) => (mainCarouselRefs.current[LocationDetail.id] = el)}
                                                    responsive={responsiveMain}
                                                    arrows={true}
                                                    infinite={false}
                                                    showDots={false}
                                                    afterChange={(_, state) => {
                                                    const realIndex = state.currentSlide % LocationDetail.media.length;
                                                    setActiveSlides((prev) => ({
                                                        ...prev,
                                                        [LocationDetail.id]: realIndex,
                                                    }));

                                                    if (dotCarouselRefs.current[LocationDetail.id]) {
                                                        const dotSlider = dotCarouselRefs.current[LocationDetail.id];
                                                        const visibleItems = 5;
                                                        const middleDot = Math.max(realIndex - Math.floor(visibleItems / 2), 0);
                                                        dotSlider.goToSlide(middleDot);
                                                    }
                                                    }}
                                                    autoPlay={!!hoveredCarousel[LocationDetail.id]}
                                                    autoPlaySpeed={1000} 
                                                    pauseOnHover
                                                    swipeable
                                                    draggable
                                                    slidesToSlide={1}
                                                    keyBoardControl
                                                >
                                                {LocationDetail.media.map((LocImage) => {
                                                    return (
                                                    <div className={CommonStyle.item} key={LocImage.id}>
                                                        <Link to={`/property-detail/${LocationDetail.location_code}`}>
                                                        <img src={IMAGE_BASE_URL + "/property/size/" + LocImage.image} alt=""/>
                                                        </Link>
                                                    </div>
                                                    );
                                                })}
                                                </Carousel>
                                                <div className={CommonStyle.linkPost}>
                                                    <div className={CommonStyle.filterList}>
                                                        {(()=>{
                                                            if(LocationDetail?.link_valid_till <= formatDateTime(dateTime) && LocationDetail?.property_allow === 1){
                                                                return <h2 className={CommonStyle.noallow}>Used or Expire </h2>
                                                            }else if(LocationDetail?.property_allow === 0){
                                                                return <h2 className={CommonStyle.pending}>Pending </h2>
                                                            }else if(LocationDetail?.open_limit !== null && LocationDetail?.opened >= Number(LocationDetail?.open_limit) && LocationDetail?.property_allow === 1){
                                                                return <h2 className={CommonStyle.noallow}>Used or Expire</h2>
                                                            }else{
                                                                return <h2 className={CommonStyle.allow}>Available </h2>
                                                            }
                                                        })()}
                                                    </div>
                                                </div>
                                                {/* Dot Carousel */}
                                                <div className={CommonStyle.sliderDots}>
                                                    <Carousel
                                                    ref={(el) => (dotCarouselRefs.current[LocationDetail.id] = el)}
                                                    responsive={responsiveDots}
                                                    arrows={true}
                                                    infinite={false}
                                                    swipeable
                                                    draggable
                                                    showDots={false}
                                                    keyBoardControl
                                                    itemClass="dot-carousel-item"
                                                    >
                                                    {LocationDetail.media.map((_, index) => (
                                                        <div
                                                        key={index}
                                                        onClick={() => handleDotClick(LocationDetail.id, index)}
                                                        className={currentActiveSlide === index ? CommonStyle.customDot + ' ' + CommonStyle.active : CommonStyle.customDot}
                                                        />
                                                    ))}
                                                    </Carousel>
                                                </div>
                                            </div>
                                            </div>
                                            <div className={CommonStyle.areaDetail}>
                                            <h6 className={FontStyle.Axiforma600}>  
                                                {(()=>{
                                                        if(LocationDetail?.link_valid_till <= formatDateTime(dateTime) && LocationDetail?.property_allow === 1){
                                                            return LocationDetail.location_code
                                                        }else if(LocationDetail?.property_allow === 0){
                                                            return LocationDetail.location_code
                                                        }else if(LocationDetail?.open_limit !== null && LocationDetail?.opened >= Number(LocationDetail?.open_limit) && LocationDetail?.property_allow === 1){
                                                            return LocationDetail.location_code
                                                        }else{
                                                            return <Link to={`/property/${LocationDetail.temp_link}`}>{LocationDetail.location_code}</Link>
                                                        }
                                                    })()}
                                                 
                                                </h6> 
                                            </div>
                                            </div>
                                        );
                                        })}
                                    </>
                                    ) : <p>No Data</p>}
                                </div>
                                </Col>
                            </Row>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>
    )
}

export default ResultDashboard;